import { render, staticRenderFns } from "./noticeBoard.vue?vue&type=template&id=eee69cc6&scoped=true"
import script from "./noticeBoard.vue?vue&type=script&lang=js"
export * from "./noticeBoard.vue?vue&type=script&lang=js"
import style0 from "./noticeBoard.vue?vue&type=style&index=0&id=eee69cc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee69cc6",
  null
  
)

export default component.exports